export function dateToISOString(date: Date | string): string {
	if (!date) return "";
	const d = typeof date === "string" ? new Date(date) : date;
	if (Number.isNaN(d.getTime())) return "";
	return d.toISOString();
}

export function parseDate(date: string | Date | null | undefined): Date | null {
	if (!date) return null;
	const d = typeof date === "string" ? new Date(date) : date;
	return Number.isNaN(d.getTime()) ? null : d;
}

const DATE_INPUT_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})$/;

export function parseDateInput(value: string): string | null {
	const match = value.match(DATE_INPUT_PATTERN);
	if (!match) return null;
	const [, month, day, year, hours, minutes] = match;
	if (!month || !day || !year || !hours || !minutes) return null;
	const date = new Date(
		Number.parseInt(year, 10),
		Number.parseInt(month, 10) - 1,
		Number.parseInt(day, 10),
		Number.parseInt(hours, 10),
		Number.parseInt(minutes, 10),
	);
	if (Number.isNaN(date.getTime())) return null;
	return date.toISOString();
}
